/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {injectIntl, IntlShape} from 'react-intl';
import {sortRules} from '../../common/model-api/ScenarioChannelDefRuleType';

import './Scenario.scss';
import config from '../../common/config';
import { Flow } from '../../common/types/types';

export const DEFAULT_SIZE = 'default';
export const MEDIUM_SIZE = 'medium';
export const SMALL_SIZE = 'small';

interface FlowIconProps {
    flow?: Flow;
    intl?: object;
    size?: unknown | unknown | unknown;
}

class FlowIcon extends React.Component<FlowIconProps> {

    static propTypes = {
        flow: PropTypes.object,
        intl: PropTypes.object,
		size: PropTypes.oneOf([DEFAULT_SIZE, MEDIUM_SIZE, SMALL_SIZE]),
    };

	static defaultProps = {
		size: DEFAULT_SIZE
	};

	getSortedChannels() {
        let flow = this.props.flow;
        let selectedChannels = JSON.parse(flow.selectedChannels);
        if (!flow.flowDef || !flow.flowDef.flowChannelDefs || !flow.channels) {
            return [];
        }

		return flow.flowDef.flowChannelDefs.edges.map(({node}) => node).filter((s2cd) => s2cd.doNotShowToUser ? false : true).map((a) => {
            let channelId = selectedChannels[a.key];
            if (!channelId) {
                return;
            }

            let channel = flow.channels.edges.map(({node}) => node).find((c) => c.realId === channelId);
            if (!channel) {
                return;
            }

            return {
                ...a,
                channelDef: channel.channelDef,
            };
        }).filter((a) => !!a).sort(sortRules);
	}

    render() {
        let {size} = this.props;

		let sortChannels = this.getSortedChannels();
		let mainIcon = null;
        let minorIcons = [];

		sortChannels.forEach((item, idx) => {
            if (!item.channelDef) {
                return;
            }

            minorIcons.push(<div className="minorIcon" key={idx}><ChannelIcon channelDef={item.channelDef} size={54}/></div>);
		});
		minorIcons = minorIcons.slice(0, 4);

		if (!mainIcon && minorIcons.length === 0) {
            mainIcon = (<div className="minorIcon"><ChannelIcon channelDef={{
                    icon: "dativery",
                    name: config.PRODUCT_NAME
                }} noDimensions size={54} /></div>);
        }

        if (!mainIcon && minorIcons.length === 1) {
            mainIcon = minorIcons[0];
            minorIcons = [];
        }

        return (
			<div className={"scenarioGridList-icons" + " count-" + minorIcons.length + " type-flow size-" + size}>
                {mainIcon ? <div className="minorIcons">{mainIcon}</div> : null }
				{minorIcons.length ? <div className="minorIcons">{minorIcons}</div> : null}
			</div>
        );
    }
}

export let RawFlowIcon = injectIntl(FlowIcon);

export default Relay.createContainer(RawFlowIcon, {
    fragments: {
        flow: () => Relay.QL`
            fragment on Flow {
                id,
                name,
                selectedChannels,
				flowDef {
                    id,
                    flowChannelDefs(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                key,
                                doNotShowToUser,
                            }
                        }
                    }
					
				},
                channels(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon
                            }
                        }
                    }
                }
            }
        `,
    },
});
